<template>
  <!-- 帮帮-找帮帮 - xxx商品详情 -->
  <div class="firm-body">
    <div class="help-body">
      <!-- 标题-->
      <p class="title-Individual-center">
        <span class="firm-clickable" @click="handelBack">帮帮</span>
        <i class="el-icon-arrow-right firm-clickable"></i><span @click="handelBack">找帮帮</span>
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center"> 洪驰供应链管理公司logo设计 </span>
      </p>
      <!-- 内容 -->
      <div class="help-Content">
        <!-- -->
        <div class="top-title">
          <p class="title">洪驰供应链管理公司logo设计</p>
          <div class="Back" @click="handelBack">
            <div class="Back-style">
              <div></div>
              <p>返回</p>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="switch-Content">
          <Product @handelEditCase="handelEditCase"></Product>
        </div>
      </div>
      <!-- 底部按钮 -->
      <div class="Bottom-Btn">
        <div>
          <p class="firm-clickable" @click="handelEnterShop">进入店铺</p>
          <p>立即沟通</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Product from "./components/Product.vue"; // 产品详情

export default {
  data() {
    return {};
  },
  watch: {},
  components: {
    // 产品详情
    Product,
  },
  created() {},
  destroyed() {},
  methods: {
    // 点击案例模块
    handelEditCase() {
      this.$router.push({
        path: "/HelpShop/Help/HelpCase",
      });
    },
    // 点击进入店铺
    handelEnterShop() {
      this.$router.push({
        path: "/HelpShop/Help/HelpShop",
      });
    },
    // 返回
    handelBack() {
      this.$router.push({
        path: "/HelpShop/Help",
        query: { key: 1 },
      });
    },
  },
};
</script>

<style scoped lang="less">
.el-icon-arrow-right {
  margin-left: 4px;
  margin-right: 4px;
}
.firm-body {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  .help-body {
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
//主体
.help-Content {
  min-width: 1140px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  margin-bottom: 20px;
  padding: 30px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  font-family: PingFangSC-Medium;
  // 标题
  .top-title {
    width: 100%;
    height: 40px;
    display: flex;
    position: relative;
    .title {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin: auto;
    }
    .Back {
      width: 110px;
      height: 30px;
      background: rgba(97, 144, 232, 0.3);
      border-radius: 5px;
      display: flex;
      position: absolute;
      right: 0;
      top: 5px;
      cursor: pointer;
      .Back-style {
        width: 50px;
        height: 17px;
        line-height: 17px;
        margin: auto;
        display: flex;
        div {
          width: 14px;
          height: 17px;
          background-image: url("../../../../assets/imgs/back-da@3x.svg");
          background-size: 100% 100%;
        }
        p {
          font-size: 14px;
          color: #409eff ;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  //
  .switch-Content {
    width: 100%;
    margin-top: 30px;
  }
}
.Bottom-Btn {
  height: 35px;
  background: #ffffff;
  box-shadow: 0px -5px 10px 0px rgba(153, 153, 153, 0.5);
  border-radius: 0px 0px 20px 20px;
  margin-top: -30px;
  margin-bottom: 20px;
  display: flex;
  padding: 20px;
  p {
    width: 100px;
    height: 30px;
    background: #409eff ;
    border-radius: 5px;
    font-size: 14px;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    margin: auto 0;
    margin-left: 20px;
  }
  div {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
